import api from '@/apis/bu/bUB58KTNNAPI';
import Crud from '@/stores/crudBase';
var crud = new Crud('bUB58KTNN', api);
const state = {
  ...crud.state,
  _config: {
    table: 'b58_ktnn',
    field: {
      key: 'master_id',
      // code: 'accounting_object_code',
      name: 'report_name',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
